<script>
import { defineComponent, onMounted } from 'vue'
import { useLandingFlow } from '../../feature/LandingFlowFeature'
import { useLocale } from '../../feature/LocaleFeature';
export default defineComponent({

    setup: () => {
        const { campaign} = useLandingFlow()
        const { lbl } = useLocale()
        const init = () => {
            console.log("campaign", campaign.value)
        }
        onMounted(() => {
            init()
        })

        const getPrice = () => {
            return campaign.value.pricePerUnit
        }

        return {
            campaign,
            getPrice,
            lbl
        }
    }
})
</script>
<template>
    <div class="bg-white">
        <div class="px-5">
            <div class="flex py-2 border-b border-a-gray-e5e5e5">
                <div><img class="h-5 my-auto mr-2"  src="../../assets/icon/store-light.svg" /></div>
                <div class="text-14 text-a-gray-4a4a4a my-auto font-medium">{{ campaign.agencyName }}</div>
            </div>
        </div>

        <div class="flex px-5 py-2">
            <div class="w-1/4">
                <div class="campaign-image border rounded-lg border-a-gray-e5e5e5" :style="{'background-image': `url('${campaign.fullImageUrl}')`}"></div>
            </div>
            <div class="w-3/4 pl-5">
                <div class="text-14 text-a-gray-4a4a4a">{{ campaign.name }}</div>
                <div class="flex w-full pt-2">
                    <div class="text-16 font-medium text-a-gray-4a4a4a ml-0 mr-auto my-auto">฿ {{FilterPriceFormat(getPrice())}}</div>
                    <div class="text-14 text-a-gray-4a4a4a mr-0 ml-auto my-auto">X1</div>
                </div>
            </div>
        </div>
        <div class="px-5">
            <div class="flex py-2 border-t border-a-gray-e5e5e5">
                <div class="text-14 text-a-gray-4a4a4a ml-0 mr-auto my-auto">1 {{ lbl.detail.unit }}</div>
                <div class="text-14 text-a-gray-4a4a4a mr-0 ml-auto my-auto">{{ lbl.detail.price }} : <span class="text-a-orange-f9a601">฿ {{FilterPriceFormat(getPrice())}}</span></div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    .campaign-image {
        @include boxRatio($ratio: 100%);
    }
</style>
